import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';


@Component({
    selector: 'bm-customer-billing-transaction-type-object-component',
    templateUrl: 'bm-customer-billing-transaction-type-object.component.html',
    standalone: false
})
export class BmCustomerBillingTransactionTypeObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {


    onObjectChanged() {

    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
